import { ReactElement, useEffect, useState } from 'react';
import { Button, Card } from '../../../../components';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Stack } from '@mui/material';
import Config from 'Config';
import { HttpSessionBreakingError } from '../HttpSessionBreakingError/HttpSessionBreakingError';
import { SocketBreakingError } from '../SocketBreakingError/SocketBreakingError';
import { AuthErrorResponseCode } from '../../../../common/types/auth-error-response';

export const CallbackSidHandled = () => {
  const { t } = useTranslation();

  const [responseReceived, setResponseReceived] = useState(false);
  const [error, setError] = useState<ReactElement | null>(null);

  useEffect(() => {
    const currentUrl = window.location.href;
    fetch(Config.SID_CALLBACK_URL + `?callbackUrl=${encodeURIComponent(currentUrl)}`, {
      method: 'GET',
      credentials: 'include',
    })
      .then(async (res) => {
        if (res.ok) {
          setResponseReceived(true);
          setTimeout(() => {
            closeTab();
          }, 3000);
        } else if (res.status === 401) {
          setError(<HttpSessionBreakingError />);
        } else {
          const callbackError = await getSidCallbackErrorCode(res);
          setError(<SocketBreakingError errorCode={callbackError} />);
        }
      })
      .catch((err) => {
        setResponseReceived(true);
        console.error('error_sending_callback', err);
      });
  }, []);

  const closeTab = () => {
    window.open('', '_self')?.close();
  };

  async function getSidCallbackErrorCode(response: Response): Promise<AuthErrorResponseCode> {
    try {
      const body = await response.json();
      if (body?.error === 'callback_error') {
        return AuthErrorResponseCode.ACCESS_DENIED;
      }
      if (body?.error === 'invalid_request') {
        return AuthErrorResponseCode.INVALID_REQUEST;
      }
    } catch {
      return AuthErrorResponseCode.SERVER_ERROR;
    }
    return AuthErrorResponseCode.SERVER_ERROR;
  }

  return (
    error || (
      <>
        <Card>
          <div aria-live="polite">
            <Stack
              direction="column"
              sx={{
                flex: '1',
                gap: '2rem',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress color="primary" />
              {responseReceived ? (
                <>
                  {t('form.sid.DeviceLink.Callback.Finished')}
                  <Button appearance="text" size="m" color="outline" onClick={closeTab}>
                    {t('form.sid.DeviceLink.Callback.Close')}
                  </Button>
                </>
              ) : (
                <>{t('form.sid.DeviceLink.Callback.Processing')}</>
              )}
            </Stack>
          </div>
        </Card>
      </>
    )
  );
};
